import { Button } from 'components/atoms/Button';
import { Typography } from 'components/atoms/Typography';
import { Stack } from 'components/base/layout/Stack';
import type { ToastContentProps } from 'react-toastify';
import {
  messageStyles,
  rootStyles,
  textGroupStyles,
  titleStyles,
} from './style';
import { Logger } from 'utils/logger';

type VersionToastProps = ToastContentProps & {
  /**
   * Called when the user defers the update ("Later"). The listener uses this to
   * hide the banner for the current version — it won't re-prompt until a newer
   * build is deployed.
   */
  onLater: () => void;
};

export function VersionToast({ closeToast, onLater }: VersionToastProps) {
  const handleRefresh = () => {
    closeToast(true);
    Logger.info({
      message: 'AppVersion: user skipped update',
      source: 'AppVersionUpdateListener',
      body: {
        appVersionUpdateSkipped: false,
      },
    });
    window.location.reload();
  };

  const handleLater = () => {
    onLater();
    closeToast(true);
    Logger.info({
      message: 'AppVersion: user deferred update',
      source: 'AppVersionUpdateListener',
      body: {
        appVersionUpdateSkipped: true,
      },
    });
  };

  return (
    <Stack gap={1.25} sx={rootStyles}>
      <Stack gap={0.5} sx={textGroupStyles}>
        <Typography variant="subtitle2" component="p" sx={titleStyles}>
          A new version is available 🎉🎉
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          component="p"
          sx={messageStyles}
        >
          Refresh the page to load the latest changes.
        </Typography>
      </Stack>
      <Stack
        direction="row"
        gap={1}
        justifyContent="flex-end"
        alignItems="center"
        flexWrap="wrap"
      >
        <Button variant="text" size="small" onClick={handleLater}>
          Later
        </Button>
        <Button variant="contained" size="small" onClick={handleRefresh}>
          Refresh page
        </Button>
      </Stack>
    </Stack>
  );
}
